import { ModalService, SimpleMessageService, Tenant, WebAppCommonModule } from '@allbesmart/web-app-common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { TenantManagementService } from 'src/app/services/tenant-management.service';

@Component({
    selector: 'oaibox-update-deployment-domain-modal',
    templateUrl: './update-deployment-domain-modal.component.html',
    styleUrls: ['./update-deployment-domain-modal.component.css'],
    imports: [WebAppCommonModule, ReactiveFormsModule],
})
export class UpdateDeploymentDomainModalComponent implements OnInit, OnDestroy {

  @Input({ required: true }) tenant!: Tenant;

  protected updateDeploymentDomainForm: UpdateDeploymentDomainFormGroup;
  private updateDeploymentDomainSubscription?: Subscription;
  
  protected ongoingRequest: boolean = false;

  constructor(
    private tenantManagementService: TenantManagementService,
    private simpleMessageService: SimpleMessageService,
    private modalService: ModalService,
  ) {
    this.updateDeploymentDomainForm = new FormGroup({
      domain: new FormControl<string | null>(null, [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.updateDeploymentDomainForm?.controls.domain.patchValue(this.tenant.clientDomain);
  }

  public save(): void {
    if (!this.tenant || this.updateDeploymentDomainForm.value.domain == null) return;

    this.ongoingRequest = true;
    this.updateDeploymentDomainSubscription?.unsubscribe();
    this.updateDeploymentDomainSubscription = this.tenantManagementService
      .updateClientDomain(this.tenant.id, this.updateDeploymentDomainForm.value.domain)
      .subscribe({
        next: () => {
          this.ongoingRequest = false;
          this.simpleMessageService.showSimpleMessage({
            message: 'Deployment domain updated successfully!',
            icon: 'fa-solid fa-check-double',
            color: 'success',
          });
          this.modalService.popModal();
        },
        error: () => {
          this.ongoingRequest = false;
          this.simpleMessageService.showSimpleMessage({
            message: 'Failed to update deployment domain!',
            icon: 'fa-solid fa-triangle-exclamation',
            color: 'danger',
          });
        }
      });
  }

  public cancel(): void {
    this.modalService.popModal();
  }

  ngOnDestroy(): void {
    this.updateDeploymentDomainSubscription?.unsubscribe();
  }

}

type UpdateDeploymentDomainFormGroup = FormGroup<{
  domain: FormControl<string | null>,
}>;
